// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table_tableHeader__z1a2J {
  display: flex;
  justify-content: space-between;
}
.Table_tableHeader__z1a2J .Table_title__xMDfY p {
  margin: 15px 0 15px 0;
  line-height: 22px;
  font-size: 20px;
}
.Table_tableHeader__z1a2J .Table_title2__HePLT p {
  margin: 15px 0 15px 0;
  line-height: 22px;
  font-size: 20px;
  color: #7367f0;
}
.Table_tableHeader__z1a2J .Table_viewAll__HcQwV {
  margin: 15px 0 15px 0;
  line-height: 22px;
  font-size: 15px;
}
.Table_tableHeader__z1a2J .Table_viewAll__HcQwV .Table_viewButton__YBzSv {
  padding: 5px 20px;
  display: flex;
  align-items: center;
  background: #7367f0;
  text-decoration: none;
  box-shadow: none;
  border: none;
  border-radius: 3px;
  letter-spacing: 1px;
}
.Table_tableHeader__z1a2J .Table_viewAll__HcQwV .Table_viewButton__YBzSv span {
  padding-left: 8px;
  color: #ffffff;
}
@media screen and (max-width: 600px) {
  .Table_tableHeader__z1a2J .Table_viewAll__HcQwV {
    font-size: 13px;
  }
  .Table_tableHeader__z1a2J .Table_viewAll__HcQwV .Table_viewButton__YBzSv {
    padding: 5px 11px;
  }
  .Table_tableHeader__z1a2J .Table_viewAll__HcQwV .Table_viewButton__YBzSv svg {
    font-size: 15px;
  }
  .Table_tableHeader__z1a2J .Table_viewAll__HcQwV .Table_viewButton__YBzSv span {
    padding-left: 4px;
  }
}
@media screen and (max-width: 600px) {
  .Table_tableHeader__z1a2J .Table_title__xMDfY p {
    font-size: 15px;
  }
  .Table_tableHeader__z1a2J .Table_title2__HePLT p {
    font-size: 15px;
  }
}

.Table_tableOuter__NjIrC {
  border: 1px solid rgba(47, 43, 61, 0.2);
  border-radius: 5px;
  margin-bottom: 15px;
}

.Table_posts__E8hG0 {
  display: flex;
  align-items: center;
}
.Table_posts__E8hG0 img {
  max-width: 100px;
}
.Table_posts__E8hG0 .Table_postTitle__IcGHO {
  color: #555;
  font-family: "Noto Serif Malayalam";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  text-transform: uppercase;
  margin-left: 5px;
}

.Table_backGroundText__lgR9i {
  padding: 10px;
  border-radius: 3px;
}

.Table_actions__zexxr {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.Table_actions__zexxr .Table_subActions__ZGdsi {
  cursor: pointer;
}

.Table_imagethumb__TFa53 {
  max-width: 150px;
  height: 100px;
  object-fit: cover;
}

.Table_adImage__BFGDA {
  max-width: 150px;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/components/Table/Table.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;AACF;AACE;EACE,qBAAA;EACA,iBAAA;EACA,eAAA;AACJ;AAEE;EACE,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAGE;EACE,qBAAA;EACA,iBAAA;EACA,eAAA;AADJ;AAGI;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AADN;AAGM;EACE,iBAAA;EACA,cAAA;AADR;AAKI;EAtBF;IAuBI,eAAA;EAFJ;EAII;IACE,iBAAA;EAFN;EAIM;IACE,eAAA;EAFR;EAKM;IACE,iBAAA;EAHR;AACF;AAQE;EACE;IACE,eAAA;EANJ;EASE;IACE,eAAA;EAPJ;AACF;;AAWA;EACE,uCAAA;EACA,kBAAA;EACA,mBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;AARF;AAUE;EACE,gBAAA;AARJ;AAWE;EACE,WAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;AATJ;;AAaA;EACE,aAAA;EACA,kBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAVF;AAYE;EACE,eAAA;AAVJ;;AAcA;EACE,gBAAA;EACA,aAAA;EACA,iBAAA;AAXF;;AAaA;EACE,gBAAA;EACA,iBAAA;AAVF","sourcesContent":[".tableHeader {\n  display: flex;\n  justify-content: space-between;\n\n  .title p {\n    margin: 15px 0 15px 0;\n    line-height: 22px;\n    font-size: 20px;\n  }\n\n  .title2 p {\n    margin: 15px 0 15px 0;\n    line-height: 22px;\n    font-size: 20px;\n    color: #7367f0;\n  }\n\n  .viewAll {\n    margin: 15px 0 15px 0;\n    line-height: 22px;\n    font-size: 15px;\n\n    .viewButton {\n      padding: 5px 20px;\n      display: flex;\n      align-items: center;\n      background: #7367f0;\n      text-decoration: none;\n      box-shadow: none;\n      border: none;\n      border-radius: 3px;\n      letter-spacing: 1px;\n\n      span {\n        padding-left: 8px;\n        color: #ffffff;\n      }\n    }\n\n    @media screen and (max-width: 600px) {\n      font-size: 13px;\n\n      .viewButton {\n        padding: 5px 11px;\n\n        svg {\n          font-size: 15px;\n        }\n\n        span {\n          padding-left: 4px;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 600px) {\n    .title p {\n      font-size: 15px;\n    }\n\n    .title2 p {\n      font-size: 15px;\n    }\n  }\n}\n\n.tableOuter {\n  border: 1px solid rgba(47, 43, 61, 0.20);\n  border-radius: 5px;\n  margin-bottom: 15px;\n}\n\n.posts {\n  display: flex;\n  align-items: center;\n\n  img {\n    max-width: 100px;\n  }\n\n  .postTitle {\n    color: #555;\n    font-family: 'Noto Serif Malayalam';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 17px;\n    text-transform: uppercase;\n    margin-left: 5px;\n  }\n}\n\n.backGroundText {\n  padding: 10px;\n  border-radius: 3px;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n\n  .subActions {\n    cursor: pointer;\n  }\n}\n\n.imagethumb {\n  max-width: 150px;\n  height: 100px;\n  object-fit: cover;\n}\n.adImage {\n  max-width: 150px;\n  object-fit: cover;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableHeader": `Table_tableHeader__z1a2J`,
	"title": `Table_title__xMDfY`,
	"title2": `Table_title2__HePLT`,
	"viewAll": `Table_viewAll__HcQwV`,
	"viewButton": `Table_viewButton__YBzSv`,
	"tableOuter": `Table_tableOuter__NjIrC`,
	"posts": `Table_posts__E8hG0`,
	"postTitle": `Table_postTitle__IcGHO`,
	"backGroundText": `Table_backGroundText__lgR9i`,
	"actions": `Table_actions__zexxr`,
	"subActions": `Table_subActions__ZGdsi`,
	"imagethumb": `Table_imagethumb__TFa53`,
	"adImage": `Table_adImage__BFGDA`
};
export default ___CSS_LOADER_EXPORT___;
